import React, { useState, useMemo, useEffect } from 'react';
import './EditFollowingModal.scss';
import { Button, Modal, SearchBox, Table, Transfer } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import RenderGameIcon from '../../RenderImg/renderGameIcon';
import { gameCollectUpdate } from '@/pages/opinion/services';
const { selectable, removeable, scrollable } = Table.addons;

interface propsType {
  visible: boolean;
  close: any;
  confirm: any;
  source: any[];
  target: any[];
}

const EditFollowingModal = (props: propsType) => {
  const { formatMessage } = useIntl();

  const columns = [
    {
      key: 'edition_unified_id',
      header: formatMessage({ id: 'Games' }),
      render: (gameInfo: any) => (
        <div className="dbo-exit-follwing">
          <RenderGameIcon
            gameInfo={gameInfo}
            className="dbo-exit-follwing-img"
          ></RenderGameIcon>

          <div className="dbo-exit-follwing-context">
            <div className="dbo-exit-follwing-name">{gameInfo.entity_name}</div>
            <div className="dbo-exit-follwing-flex">
              <SvgIcon
                className="dbo-exit-follwing-icon"
                type={
                  gameInfo.entity_type == 'mobile'
                    ? 'other-icon'
                    : gameInfo.entity_type == 'pc'
                    ? 'monitor'
                    : 'merit'
                }
              />
              <span className="dbo-exit-follwing-text">
                {gameInfo.entity_name_cn || gameInfo.entity_name}
              </span>
            </div>
          </div>
        </div>
      ),
    },
  ];

  let { visible, close, confirm, source = [], target = [] } = props;

  const [targetKeys, setTargetKeys] = useState<string[]>([]);

  const [inputValue, setInputValue] = useState<string>('');

  const tableSource = useMemo(() => {
    return source
      .filter((item: any) => targetKeys.includes(item.edition_unified_id))
      .sort((a: any, b: any) => {
        return (
          targetKeys.indexOf(a.edition_unified_id) -
          targetKeys.indexOf(b.edition_unified_id)
        );
      });
  }, [targetKeys]);

  useEffect(() => {
    setTargetKeys(target.map((item) => item.edition_unified_id));
  }, [target]);

  const handleCancel = () => {
    close?.();
  };

  const handleConfirm = async () => {
    try {
      const newCollectList = targetKeys;
      await gameCollectUpdate({
        edition_unified_ids: newCollectList,
      });
      confirm?.(newCollectList);
    } catch {}
  };

  return (
    <Modal
      className="dbo-source-table-modal"
      visible={visible}
      size={1130}
      caption={formatMessage({ id: 'Edit My Following Games' })}
      onClose={close}
    >
      <Modal.Body>
        <Transfer
          leftCell={
            <Transfer.Cell
              scrollable={false}
              title={formatMessage({ id: 'All Games' })}
              //   tip="支持按住 shift 键进行多选"
              header={
                <SearchBox
                  className="dbo-source-table-search"
                  value={inputValue}
                  placeholder={formatMessage({ id: 'Search' })}
                  onChange={(value) => setInputValue(value)}
                />
              }
            >
              <Table
                className="dbo-source-table-left"
                records={source.filter((item) => {
                  const lowerCaseInputValue = inputValue.toLowerCase();
                  return [
                    'entity_name',
                    'entity_name_cn',
                    'entity_name_en',
                  ].some((key) =>
                    item[key]?.toLowerCase?.()?.includes?.(lowerCaseInputValue),
                  );
                })}
                hideHeader
                recordKey="edition_unified_id"
                columns={columns}
                addons={[
                  scrollable({
                    virtualizedOptions: {
                      height: 535,
                      itemHeight: 65,
                    },
                  }),
                  selectable({
                    value: targetKeys,
                    onChange: (
                      value: string[],
                      { checked, recordKey }: any,
                    ) => {
                      if (checked) {
                        setTargetKeys([...targetKeys, recordKey]);
                      } else {
                        setTargetKeys(
                          targetKeys.filter((item) => item !== recordKey),
                        );
                      }
                    },
                    rowSelect: true,
                  }),
                ]}
              />
            </Transfer.Cell>
          }
          rightCell={
            <Transfer.Cell
              scrollable={false}
              title={`${formatMessage({ id: 'Selected' })} (${
                targetKeys.length
              })`}
            >
              <Table
                className="dbo-source-table-right"
                records={tableSource}
                recordKey="edition_unified_id"
                columns={columns}
                addons={[
                  scrollable({
                    virtualizedOptions: {
                      height: 534,
                      itemHeight: 65,
                    },
                  }),
                  removeable({
                    onRemove: (key) =>
                      setTargetKeys(targetKeys.filter((item) => item !== key)),
                  }),
                ]}
              />
            </Transfer.Cell>
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleConfirm}>
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button type="weak" onClick={handleCancel}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFollowingModal;
